import React, { useEffect, useRef } from "react"

const SEEK_TOLERANCE_SECONDS = 1

const GuardedVideo = ({ src, startAt = 0, onProgress, onEnded }) => {
  const ref = useRef(null)
  const maxRef = useRef(startAt || 0)
  const restoring = useRef(false)

  useEffect(() => {
    maxRef.current = startAt || 0
  }, [src, startAt])

  const report = (video) => {
    onProgress?.({
      position: video.currentTime,
      maxReached: maxRef.current,
      duration: Number.isFinite(video.duration) ? video.duration : null,
    })
  }

  const handleLoaded = (e) => {
    const video = e.currentTarget
    if (startAt > 0 && startAt < (video.duration || Infinity)) {
      restoring.current = true
      video.currentTime = startAt
    }
    report(video)
  }

  const handleTimeUpdate = (e) => {
    const video = e.currentTarget
    if (!video.seeking && video.currentTime > maxRef.current) maxRef.current = video.currentTime
    report(video)
  }

  const handleSeeking = (e) => {
    const video = e.currentTarget
    if (restoring.current) {
      restoring.current = false
      return
    }
    if (video.currentTime > maxRef.current + SEEK_TOLERANCE_SECONDS) {
      video.currentTime = maxRef.current
    }
  }

  const handleEnded = (e) => {
    const video = e.currentTarget
    if (Number.isFinite(video.duration)) maxRef.current = video.duration
    report(video)
    onEnded?.()
  }

  return (
    <video
      ref={ref}
      src={src}
      controls
      controlsList="nodownload noplaybackrate"
      disablePictureInPicture
      playsInline
      style={{ width: "100%", maxHeight: "70vh", background: "#000", borderRadius: 8 }}
      onLoadedMetadata={handleLoaded}
      onTimeUpdate={handleTimeUpdate}
      onSeeking={handleSeeking}
      onEnded={handleEnded}
    >
      Your browser does not support video playback.
    </video>
  )
}

export default GuardedVideo
